export default __webpack_public_path__ + "static/media/message-open.b7317f24.png";